export default __webpack_public_path__ + "static/media/plain-sticker-u.84a6560e.png";